<template>
    <vx-card title="Редактирование пользователя" id="loader">
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input readonly autocomplete="off" v-model="form.email" label="Логин"
                        class="mt-1 w-full required" />
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input placeholder="Введите имя..." autocomplete="off" v-model="form.firstName"
                        :danger="!!errors.firstName" :danger-text="errors.firstName" label="Имя"
                        class="mt-1 w-full required" />
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input placeholder="Введите фамилию..." autocomplete="off" v-model="form.lastName"
                        :danger="!!errors.lastName" :danger-text="errors.lastName" label="Фамилия"
                        class="mt-1 w-full required" />
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input placeholder="Введите телефон..." autocomplete="off" v-model="form.phoneNumber"
                        label="Телефон" class="mt-1 w-full" />
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input placeholder="Введите skype..." autocomplete="off" v-model="form.skype" label="Skype"
                        class="mt-1 w-full" />
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input placeholder="Введите лимит..." autocomplete="off" type="number"
                        v-model="form.dailyAdsLimit" label="Дневной лимит объявлений" class="mt-1 w-full" />
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <label class="vs-input--label"> Тип баинга </label>
                    <v-select :options="dicts.buyingTypes" label="name" placeholder="Выберите тип баинга" class="w-full"
                        v-model="form.buyingTypeId" :reduce="(b) => b.id">
                    </v-select>
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <label class="vs-input--label"> Тип аккаунта </label>
                    <v-select :options="dicts.userTypes" label="name" placeholder="Выберите тип аккаунта" class="w-full"
                        v-model="form.userTypeId" :reduce="(b) => b.id">
                    </v-select>
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <label class="vs-input--label"> Тип обслуживания </label>
                    <v-select :options="dicts.userServiceTypes" label="name" placeholder="Выберите тип обслуживания"
                        class="w-full" v-model="form.userServiceTypeId" :reduce="(b) => b.id">
                    </v-select>
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <label class="vs-input--label"> Тип сверки статистики </label>
                    <v-select :options="dicts.statisticReconciliationTypes" label="name"
                        placeholder="Выберите тип сверки статистики" class="w-full"
                        v-model="form.statisticReconciliationTypeId" :reduce="(b) => b.id">
                    </v-select>
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input label="Агентская комиссия, %" v-model="form.commissionAgency" class="mt-1 w-full"
                        type="number" min="0" :disabled="form.userTypeId != 3" :danger="!!errors.commissionAgency"
                        :danger-text="errors.commissionAgency" />
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input placeholder="Введите id кампаний (через запятую)..." autocomplete="off"
                        v-model="form.agencyCampaigns" label="Список кампаний агентства" class="mt-1 w-full" />
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <label class="vs-input--label"> Открыть статистику для SSP </label>
                    <v-select multiple :options="dicts.sspTypes" label="name" placeholder="Выберите SSP" class="w-full"
                        v-model="form.sspTypeStatisticIds" :reduce="(b) => b.id">
                    </v-select>
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <label class="vs-input--label"> Открыть статистику для DSP </label>
                    <v-select multiple :options="dicts.dspTypes" label="name" placeholder="Выберите DSP" class="w-full"
                        v-model="form.dspTypeStatisticIds" :reduce="(b) => b.id">
                    </v-select>
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <label class="vs-input--label"> Откуда узнал о платформе </label>
                    <v-select :clearable="false" :options="dicts.registrationSources" label="name"
                        placeholder="Выберите вариант" class="w-full" v-model="form.registrationSourceId"
                        :reduce="(rs) => rs.id">
                    </v-select>
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <label class="vs-input--label"> Ответственный менеджер </label>
                    <v-select :clearable="false" :options="dicts.responsibleManagers" placeholder="Выберите менеджера"
                        label="name" class="w-full" v-model="form.responsibleManager">
                    </v-select>
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <label class="vs-input--label"> Руководитель ответственного менеджера </label>
                    <v-select :clearable="false" :options="dicts.responsibleManagers"
                        placeholder="Выберите руководителя" label="name" class="w-full"
                        v-model="form.responsibleManagerChief">
                    </v-select>
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <label class="vs-input--label"> Главный аккаунт </label>
                    <v-select :clearable="false" :options="dicts.masterAccounts" placeholder="Выберите мастер аккаунт"
                        label="name" class="w-full" v-model="form.masterAccount">
                    </v-select>
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <label class="vs-input--label"> Сотрудник поддержки </label>
                </div>
            </div>
        </div>

        <div class="vx-row mb-2" v-if="this.isTeamMasterAccount">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <label class="vs-input--label"> Список сабаккаунтов в мастер аккаунте </label>
                    <v-select multiple :clearable="false" :options="dicts.users" placeholder="Выберите пользователей"
                        label="name" class="w-full" v-model="form.teamSubAccountIds" :reduce="(b) => b.id">
                    </v-select>
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/8">
                <div class="mt-1">
                    <label class="vs-input--label"> e-mail подтвержден </label>
                    <vs-checkbox class="mt-3" icon="check" color="rgb(38, 187, 174)"
                        v-model="form.emailConfirmed"></vs-checkbox>
                </div>
            </div>
            <div class="vx-col w-1/8">
                <div class="mt-1">
                    <label class="vs-input--label"> Главный аккаунт </label>
                    <vs-checkbox class="mt-3" icon="check" color="rgb(38, 187, 174)"
                        v-model="form.isMasterAccount"></vs-checkbox>
                </div>
            </div>
        </div>

        <vs-button class="mt-5 mr-2" color="success" @click="saveUser()" type="filled"> Сохранить </vs-button>

        <vs-button class="mt-5" color="primary" @click="cancelEdit()" type="filled"> Отмена </vs-button>
    </vx-card>
</template>


<script>
import axios from 'axios';
import vSelect from 'vue-select';
import ROLES from 'config/roles';

export default {
    props: ['id'],
    data() {
        return {
            user: undefined,
            isTeamMasterAccount: false,
            form: {
                email: undefined,
                firstName: undefined,
                lastName: undefined,
                phoneNumber: undefined,
                skype: undefined,
                dailyAdsLimit: undefined,
                emailConfirmed: undefined,
                createdAt: undefined,
                lastLoginAt: undefined,
                buyingTypeId: undefined,
                userTypeId: undefined,
                userServiceTypeId: undefined,
                statisticReconciliationTypeId: undefined,
                commissionAgency: undefined,
                agencyCampaigns: undefined,
                sspTypeStatisticIds: undefined,
                dspTypeStatisticIds: undefined,
                registrationSourceId: undefined,
                responsibleManager: undefined,
                responsibleManagerChief: undefined,
                masterAccount: undefined,
                isMasterAccount: undefined,
                supportUser: undefined,
                teamSubAccountIds: undefined
            },
            dicts: {
                buyingTypes: [],
                sspTypes: [],
                dspTypes: [],
                registrationSources: [],
                responsibleManagers: [],
                masterAccounts: [],
                supportUsers: [],
                users: [],
                statisticReconciliationTypes: [],
            },
            errors: {
                firstName: '',
                lastName: '',
                userTypeId: '',
                userServiceTypeId: '',
                commissionAgency: '',
                agencyCampaigns: ''
            }
        };
    },
    mounted() {
        this.loadData();
    },
    components: {
        vSelect
    },
    methods: {
        loadData() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.axios
                .all([this.axios.get('users/' + this.id), this.axios.get('users/dicts')])
                .then(
                    axios.spread((user, dicts) => {
                        this.user = user.data;
                        this.dicts = dicts.data;
                        this.setUser(user.data);
                    })
                )
                .catch((err) => {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки данных.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        setUser(user) {
            this.form.email = user.email;
            this.form.firstName = user.firstName;
            this.form.lastName = user.lastName;
            this.form.phoneNumber = user.phoneNumber;
            this.form.skype = user.skype;
            this.form.dailyAdsLimit = user.dailyAdsLimit;
            this.form.emailConfirmed = user.emailConfirmed;
            this.form.createdAt = user.createdAt;
            this.form.lastLoginAt = user.lastLoginAt;
            this.form.buyingTypeId = user.buyingTypeId;
            this.form.userTypeId = user.userTypeId;
            this.form.userServiceTypeId = user.userServiceTypeId;
            this.form.commissionAgency = user.commissionAgency;
            if (user.agencyCampaigns) {
                this.form.agencyCampaigns = user.agencyCampaigns.join(',');
            }
            this.form.sspTypeStatisticIds = user.sspTypeStatisticIds;
            this.form.dspTypeStatisticIds = user.dspTypeStatisticIds;
            this.form.registrationSourceId = this.dicts.registrationSources.find((rs) => rs.id == user.registrationSourceId).id;
            this.form.responsibleManager =
                user.responsibleManagerId > 0
                    ? this.dicts.responsibleManagers.find((rm) => rm.id == user.responsibleManagerId)
                    : this.dicts.responsibleManagers.find((rm) => rm.id == 0);
            this.form.responsibleManagerChief =
                user.responsibleManagerChiefId > 0
                    ? this.dicts.responsibleManagers.find((rm) => rm.id == user.responsibleManagerChiefId)
                    : this.dicts.responsibleManagers.find((rm) => rm.id == 0);
            this.form.masterAccount =
                user.masterAccountId > 0
                    ? this.dicts.masterAccounts.find((rm) => rm.id == user.masterAccountId)
                    : this.dicts.masterAccounts.find((rm) => rm.id == 0);
            this.form.isMasterAccount = user.isMasterAccount;
            this.form.supportUser =
                user.supportUserId > 0
                    ? this.dicts.supportUsers.find((rm) => rm.id == user.supportUserId)
                    : this.dicts.supportUsers.find((rm) => rm.id == 0);

            this.form.statisticReconciliationTypeId = user.statisticReconciliationTypeId;
            this.isTeamMasterAccount = this.user && this.user.roles.some((role) => role == ROLES.team_master_account);
            if (user.teamSubAccountIds) {
                this.form.teamSubAccountIds = user.teamSubAccountIds;
            }

        },
        clearEdit() {
            this.setUser(this.user);
        },
        cancelEdit() {
            this.$router.push('/users');
        },
        saveUser() {
            let agencyCampaigns = [];
            if (this.form.agencyCampaigns) {
                agencyCampaigns = this.form.agencyCampaigns
                    .split(',')
                    .map((i) => {
                        return i.trim();
                    })
                    .filter((i) => i != '' && !isNaN(i));
            }

            const params = Object.assign({}, this.form, {
                userId: this.id,
                agencyCampaigns,                
                sspTypeStatisticIds: this.form.sspTypeStatisticIds,
                dspTypeStatisticIds: this.form.dspTypeStatisticIds,
                responsibleManagerId: this.form.responsibleManager ? this.form.responsibleManager.id : undefined,
                responsibleManagerChiefId: this.form.responsibleManagerChief ? this.form.responsibleManagerChief.id : undefined,
                masterAccountId: this.form.masterAccount.id,
                supportUserId: this.form.supportUser ? this.form.supportUser.id : undefined,
                teamSubAccountIds: this.form.teamSubAccountIds ? this.form.teamSubAccountIds : undefined,
            });

            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.$axios({
                method: 'PUT',
                url: 'users/' + this.id,
                params: params,
                errors: this.errors,
                success: (user) => {
                    this.$vs.notify({
                        title: 'Успешно обновлено',
                        text: 'Данные пользователя успешно обновлены.',
                        color: 'success'
                    });
                    this.$router.push('/users');
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Ошибка при сохранении данных пользователя!',
                        color: 'danger'
                    });
                },
                finally: () => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                }
            });
        }
    },
    watch: {
        'form.userTypeId'() {
            if (this.form.userTypeId != 3) {
                this.form.commissionAgency = 0;
            }
        }
    },
    beforeCreate() {
        // Установка заголовка вкладки
        document.title = 'Редактирование  пользователя';
    }
};
</script>